export const MOBILE_SIZE = '(max-width: 900px)';
export const TABLET_SIZE = '(min-width: 700px) and (max-width: 900px)';
export const WIDE_SCREEN = '(min-width: 1600px)';
